import { useTranslation } from 'react-i18next';
import { ListPageLayout } from '@/components/templates';
import { PromotionListContainer } from '@/features/promotions/containers/promotion-list-container';

export default function PromotionsPage() {
  const { t } = useTranslation();

  return (
    <ListPageLayout title={t('promotions.title')}>
      <PromotionListContainer />
    </ListPageLayout>
  );
}
